import { MouseEventHandler } from 'react';

import RoundButton from 'components/BackButton';
import { ArrowLeft, Cross } from 'components/Icon';
import { Text } from 'components/library';

import * as S from './styled';

type ModalHeaderProps = {
    onClose: MouseEventHandler<HTMLButtonElement> & (() => void);
    onBack?: (MouseEventHandler<HTMLButtonElement> & (() => void)) | null;
    title: string;
};

const ModalHeader = ({ onClose, onBack, title }: ModalHeaderProps) => (
    <S.Container>
        {onBack && (
            <S.ReturnBack
                data-locator="cancelSubscriptionModalBackButton"
                data-testid="cancelSubscriptionModalBackButton"
            >
                <RoundButton onClick={onBack} badgeColor="text-main" backgroundColor="surface-secondary">
                    <ArrowLeft />
                </RoundButton>
            </S.ReturnBack>
        )}
        <Text center type="large-text">
            {title}
        </Text>
        <S.CloseButton
            data-locator="cancelSubscriptionModalCloseButton"
            data-testid="cancelSubscriptionModalCloseButton"
        >
            <RoundButton onClick={onClose} badgeColor="text-main" backgroundColor="surface-secondary">
                <Cross color="text-main" />
            </RoundButton>
        </S.CloseButton>
    </S.Container>
);

export default ModalHeader;
